import React from 'react';
import './TarjetaInfoLibro.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuoteRight, faHeart} from '@fortawesome/free-solid-svg-icons'

const TarjetaInfoLibro = (props)=>{
    return(<div className="tarjeta-info-libro">
        <img alt="img-usuario" src={props.info.imgAutor}/>
        <h1>{props.info.nombresAutor}</h1>
        <div>{props.info.porcAmor}%{'  '}
         <FontAwesomeIcon icon={faHeart} color="#f54b42"/></div>
        <div>{props.info.numCom>1000?(props.info.numCom/1000)+'k':props.info.numCom}{'  '} 
         <FontAwesomeIcon icon={faQuoteRight} color="#52a84c"/></div>
    </div>)
}

export default TarjetaInfoLibro;